// @flow
import { handleActions, combineActions } from 'redux-actions';

import {
  INIT_WAG_TAG,
  GET_WAG_TAG,
  GET_WAG_TAG_SUCCESS,
  GET_WAG_TAG_FAILURE,
  REGISTER_WAG_TAG,
  REGISTER_WAG_TAG_SUCCESS,
  REGISTER_WAG_TAG_FAILURE,
  UPDATE_WAG_TAG_SUCCESS,
  UPDATE_WAG_TAG_FAILURE,
  MANAGE_WAG_TAG_PLAN_SUCCESS,
} from '../../actions/actionTypes';

import { createAddressString } from '../../utils';

const initialState = {
  address: {
    street: '',
    apt: '',
    zipcode: '',
    state: '',
  },
  dog: {
    age: '',
    breed: '',
    name: '',
    image_url: '',
    sterile: '',
    vaccinations: [],
  },
  email: '',
  emergencyContacts: [],
  id: null,
  isCompletePlan: false,
  name: '',
  notes: '',
  phone: '',
  serialNumber: '',
  shelter: undefined,
  veterinarian: {
    address: '',
    name: '',
    email: '',
    phone: '',
  },
};

export const wagTag = handleActions(
  {
    [INIT_WAG_TAG]: (state, {
      payload: {
        serialNumber,
        isCompletePlan,
      },
    }) => (
      {
        ...state,
        serialNumber,
        isCompletePlan: isCompletePlan || false,
      }
    ),
    [GET_WAG_TAG]: state => (
      {
        ...state,
      }
    ),
    [GET_WAG_TAG_SUCCESS]: (state, {
      payload: {
        profile,
        shelter,
      },
    }) => (
      {
        ...state,
        // Profile returns null when Wag Tag doesn't exist; parse it conditionally
        ...(profile && {
          address: profile.address,
          dog: profile.dog,
          email: profile.email,
          emergencyContacts: profile.backup_contacts,
          id: profile.wag_tag_id,
          name: profile.name,
          notes: profile.notes,
          phone: profile.phone,
          serialNumber: profile.serial_number,
          veterinarian: profile.veterinarian,
        }),
        // Not every Wag Tag has an associated shelter; parse it conditionally
        shelter: shelter && {
          ...shelter,
          address: createAddressString({
            ...shelter.address,
            zipCode: shelter.address.zipcode,
          }),
        },
      }
    ),
    [GET_WAG_TAG_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [REGISTER_WAG_TAG]: state => (
      {
        ...state,
      }
    ),
    [REGISTER_WAG_TAG_SUCCESS]: (state, {
      payload: {
        wag_tag: {
          wag_tag_id: id,
          serial_number: serialNumber,
          notes,
          name: ownerName,
          phone: ownerPhone,
          email: ownerEmail,
          address: {
            street,
            apt,
            zipcode,
            state: addressState,
          },
          dog: {
            age,
            breed,
            name: dogName,
            image_url: imageUrl,
            sterile,
            vaccinations,
          },
          veterinarian,
          backup_contacts: emergencyContacts,
        },
      },
    }) => (
      {
        ...state,
        id,
        serialNumber,
        notes,
        name: ownerName,
        phone: ownerPhone,
        email: ownerEmail,
        address: {
          street,
          apt,
          zipcode,
          state: addressState,
        },
        dog: {
          age,
          breed,
          name: dogName,
          imageUrl,
          sterile,
          vaccinations,
        },
        veterinarian: {
          ...veterinarian,
        },
        emergencyContacts,
      }
    ),
    // Should we consider the normalized structure and the standard parser (https://github.com/waglabs/wagtag-web/pull/169)?
    [UPDATE_WAG_TAG_SUCCESS]: (state, {
      payload: {
        wag_tag: {
          contact_info: {
            address: {
              street,
              apt,
              zipcode,
              state: addressState,
            },
            email,
            first_name: firstName,
            last_name: lastName,
            phone,
          },
          dog: {
            age,
            breed,
            id,
            image_url: imageUrl,
            name,
            sterile,
            vaccinations,
          },
          notes,
          plan_type: planType,
          serial_number: serialNumber,
          will_renew: willRenew,
        },
      },
    }) => ({
      ...state,
      address: {
        street,
        apt,
        zipcode,
        state: addressState,
      },
      email,
      firstName,
      lastName,
      phone,
      dog: {
        age,
        breed,
        id,
        imageUrl,
        name,
        sterile,
        vaccinations,
      },
      notes,
      planType,
      serialNumber,
      willRenew,
    }),
    [combineActions(
      REGISTER_WAG_TAG_FAILURE,
      UPDATE_WAG_TAG_FAILURE,
    )]: state => (
      {
        ...state,
      }
    ),
    [MANAGE_WAG_TAG_PLAN_SUCCESS]: state => ({
      ...state,
      isCompletePlan: true,
    }),
  },
  initialState,
);
